import React from 'react';
import { generatePath, useParams } from 'react-router-dom';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { API_COMPANY_USER_ITEM } from '../../constants';

type Props = {
  userId: string;
  open: boolean;
  onClose: ModalCloseHandler;
};

function CompanyUsersDeleteModal({ userId, open, onClose }: Props) {
  const { showAlert } = useAlert();
  const { companyId } = useParams();

  const [handleRemove, loading] = useStatefulApi(
    () =>
      pepApiRequest({
        method: RequestMethod.Delete,
        url: generatePath(API_COMPANY_USER_ITEM, {
          companyId,
          userId,
        }),
      }),
    () => {
      showAlert({
        type: AlertType.Info,
        title: 'Unassigned company user',
        text: 'Company user has been unassigned.',
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  return (
    <ModalDialog
      open={open}
      title="Unassign user"
      text={`Are you sure to unassign the user: ${userId}?`}
      loading={loading}
      onClose={onClose}
      onConfirm={handleRemove}
      cancelBtnText="No"
      confirmBtnText="Yes"
    />
  );
}

export default CompanyUsersDeleteModal;
